import React from "react";
const ApplauseLargeIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={62}
      height={62}
      viewBox="0 0 62 62"
      xmlns="http://www.w3.org/2000/svg"
      fill="var(--color-theme-600)"
      ref={svgRef}
      {...props}
    >
      <g fillRule="evenodd" strokeWidth={3}>
        <path
          d="M36.521 33.36L21.017 19.89s-4.163-3.467-8.087.738c-.87.932-1.273 1.925-1.5 2.794-.534 2.04.323 4.195 1.976 5.504L29.39 41.589l-11.017-8.736s-2.865-2.262-5.867.757c-2.43 2.445-3.307 5.34 1.181 9.18l15.85 13.317s17.024 11.96 28.228-3.686c6.03-8.42.542-7.998 2-30.124 0 0-.04-5-5.416-5-5.375 0-4.584 12.5-4.584 12.5L30.08 13.962s-4.058-3.29-7.086 0c-3.74 4.062.4 7.85.4 7.85L36.521 33.36z"
          stroke="#000"
        />
        <path
          d="M27.521 25.76L12.017 12.29s-4.163-3.467-8.087.738c-.87.932-1.273 1.925-1.5 2.794-.534 2.04.323 4.195 1.976 5.504L20.39 33.989 9.372 25.253s-2.865-2.262-5.867.757c-2.43 2.445-3.307 5.34 1.181 9.18l15.85 13.317s17.024 11.96 28.228-3.686c6.03-8.42.542-7.998 2-30.124 0 0-.04-5-5.416-5-5.375 0-4.584 12.5-4.584 12.5L21.08 6.362s-4.058-3.29-7.086 0c-3.74 4.062.4 7.85.4 7.85L27.521 25.76z"
          stroke="#000"
        />
        <path
          d="M36.521 33.36L21.017 19.89s-4.163-3.467-8.087.738c-.87.932-1.273 1.925-1.5 2.794-.534 2.04.323 4.195 1.976 5.504L29.39 41.589l-11.017-8.736s-2.865-2.262-5.867.757c-2.43 2.445-3.307 5.34 1.181 9.18l15.85 13.317s17.024 11.96 28.228-3.686c6.03-8.42.542-7.998 2-30.124 0 0-.04-5-5.416-5-5.375 0-4.584 12.5-4.584 12.5L30.08 13.962s-4.058-3.29-7.086 0c-3.74 4.062.4 7.85.4 7.85L36.521 33.36z"
          stroke="#000"
        />
        <path
          stroke="#29ABE2"
          strokeLinecap="round"
          d="M46 1.5V5M52.702 7.048l4.596-4.596M39.298 7.048l-4.596-4.596"
        />
      </g>
    </svg>
  )
);
ApplauseLargeIcon.displayName = "ApplauseLargeIcon";
export default ApplauseLargeIcon;
